import { render } from "./FreeIcon.vue?vue&type=template&id=3e621a61"
import script from "./FreeIcon.vue?vue&type=script&lang=js"
export * from "./FreeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__